const ENV = process.env.REACT_APP_NODE_ENV;
const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';
// const BASE_URL_PN = ENV === 'production' ? process.env.REACT_APP_BASE_URL_PN : process.env.REACT_APP_BASE_URL_PN_STAGING;

export const fetchUserEconomicsApi = async (userEmail) => {
  try {
    console.log('Fetching economics forecasts for user ' + userEmail + '...');

    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'email': userEmail
      },
    };

    const economics = await fetch(`${BASE_URL_SSD}/economics`, options).catch(error => []);
    return economics.json();
  } catch (error) {
    console.log(error);
    return [];
  };
};

export const fetchPriceDecksApi = async () => {
  try {
    console.log('Fetching economics price decks');

    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      },
    };

    const priceDecks = await fetch(`${BASE_URL_SSD}/economics/pricedecks`, options);
    return priceDecks.json();

  } catch (error) {
    console.log(error);
    return [];
  };
};

export const fetchEconomicsApi = async (economicsIds) => {
  try {
    console.log('Fetching ' + economicsIds?.length + ' economics forecasts...');

    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'economics_ids': economicsIds
      },
    };

    let economics = await fetch(`${BASE_URL_SSD}/economics`, options);
    return economics.json();
  } catch (error) {
    console.log(error);
    return null;
  };
};

export const saveEconomicsApi = async (economics) => {
  try {
    if (!economics) return null;

    console.log('Saving ' + economics?.name + ' economics forecast...');

    let newEconomics = {...economics};
    newEconomics.lastModified = new Date();
    delete newEconomics.wellUwis;
    delete newEconomics.listIds;
    delete newEconomics.typeCurveIds;
    delete newEconomics.groupWellIds;

    console.log(newEconomics);

    const res = await fetch(`${BASE_URL_SSD}/economics`, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY
      },
      body: JSON.stringify({economics: newEconomics})
    });

    if (res.status === 200) {
      console.log('Economics ' + economics?.name + ' saved to the database successfully!');
      return { success: true };
    } else {
      console.log('Could not save economics ' + economics?.name + '!');
      return { success: false };
    };

  } catch (error) {
    console.log(error);
    return null;
  };
};

export const deleteEconomicsApi = async (economicsId) => {
  try {
    if (!economicsId) return null;

    console.log('Deleting economics forecast with id ' + economicsId + '...');

    const res = await fetch(`${BASE_URL_SSD}/economics`, {
      method: 'DELETE',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
        'economics_id': economicsId
      },
    });

    if (res.status === 200) {
      console.log('Economics ' + economicsId + ' deleted successfully!');
      return { success: true };
    } else {
      console.log('Could not delete economics ' + economicsId + '!');
      return { success: false };
    };

  } catch (error) {
    console.log(error);
    return null;
  };
};

// export const fetchCommodityPricesApi = async () => {

//   try {
//     console.log('Fetching commodity prices...');

//     const options = {
//       method: 'GET',
//       headers: {
//         'x-api-key': process.env.REACT_APP_API_KEY,
//         'Content-Type': 'application/json',
//       },
//     };

//     let result = await fetch(`${BASE_URL_PN}/commodity_price_forecast`, options);

//     if (result.status === 200) {
//       let prices = await result.json();
//       let pricesUSD = prices.filter(p => p['currency_name'] === 'U.S. Dollar');
//       let pricesCAD = prices.filter(p => p['currency_name'] === 'Canadian Dollar');

//       const pivotedPricesUSD = pivotDataByDate(pricesUSD, options); // pivot the data by the date for us commodities
//       const pivotedPricesCAD = pivotDataByDate(pricesCAD, options); // pivot the data by the date for ca commodities

//       return { usd: pivotedPricesUSD, cad: pivotedPricesCAD };
//     };
//   } catch (error) {
//     console.log('Error fetching commodity prices!');
//     console.log(error);
//     return false;
//   };
// };

// function pivotDataByDate(data) {
//   try {
//     if (!data || data.length === 0) return;
//     const result = {};

//     for (let item of data) {
//       const date = new Date(new Date(item.date).setDate(1));
//       const product = item.description?.replace(/"|'|\n/ig,"");
//       const price = Number(item.price);
  
//       if (!result[date]) {
//         result[date] = {};
//       };
//       result[date][product] = price;
//     };

//     let resultArray = Object.keys(result).map((date) => ({
//       date,
//       ...result[date],
//     }));
  

//     return resultArray;
    
//   } catch (error) {
//     console.log(error);
//   };
// };


export const fetchExchangeRateApi = async () => {

  try {
    console.log('Fetching exchange rate...');

    const options = {
      method: 'GET',
      mode: 'no-cors',
      headers: {
        'Access-Control-Allow-Origin': '*'
      },
    };

    let result = await fetch(`https://bankofcanada.ca/valet/observations/FXCADUSD?recent=1`, options);

    if (result.status === 200) {

      result = await result.json();
      let exchangeRate = { date: result?.observations?.[0]?.d, value: result?.observations?.[0]?.FXCADUSD?.v}

      return { exchangeRate };
    };
  } catch (error) {
    console.log('Error fetching commodity prices!');
    console.log(error);
    return false;
  };
};

export const loadEconomicsAPI = async (location, id, userEmail) => {

  try {
    console.log('Loading economics from ' + location + '...');

    let result = await fetch(location);

    if (result.status === 200) {
      let economics = await result.json();

      return {...economics, location: location, id: id, createdBy: userEmail};
    } else {
      return null;
    };
  } catch (error) {
    console.error('Error loading type curve!');
    console.error(error);
    return null;
  };
};